// dependencies
import moment from "moment";
import { CreateProcess } from "redux-process";

import serializeObject from "../../utils/SerializeObject";

export const reviewCycleGetForms = CreateProcess({
	method: "GET",
	name: "get forms report",
	type: "[] Get forms report",

	request: (props) => {
		const queryParams = serializeObject(props.params);

		return {
			url: `/api/form-report/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { totalCount } = data;

		const reviewReports = data.reviewReports.map((report) => {
			report.id = report._id;
			report.startDate = report.start_date ? moment(report.start_date) : null;
			report.completeDate = report.complete_date ? moment(report.complete_date) : null;
			report.authorsDueDate = report.authors_due_date ? moment(report.authors_due_date) : null;
			report.signersDueDate = report.signers_due_date ? moment(report.signers_due_date) : null;

			return report;
		});

		return {
			totalCount,
			reviewReports,
		};
	},
});
